import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { userEntersEmail } from '../actions/Actions';
import { IState, IUserInfo } from '../CustomTypes';
import InputField from '../input-components/InputField';
import { validateEmail } from '../validators';

export interface IActionProps {
  userEntersEmail: userEntersEmail;
}

export interface IParamProps {
  initialFocus?: boolean;
  formSubmitted?: boolean;
}

export interface IStateProps {
  userInfo: IUserInfo;
}

export interface IProps extends IParamProps, IStateProps, IActionProps {}

export class Email extends React.Component<IProps> {
  public render() {
    const { email } = this.props.userInfo;
    const { initialFocus, formSubmitted } = this.props;
    return (
      <InputField
        value={email}
        initialFocus={initialFocus}
        onChange={e => this.props.userEntersEmail(e.currentTarget.value)}
        formSubmitted={formSubmitted}
        label="E-post"
        placeholder="ola.nordmann@gmail.com"
        type={'email'}
        maxLength={320}
        validationErrorMessage="Vennligst oppgi en gyldig e-post adresse"
        validator={validateEmail}
      />
    );
  }
}

export default connect(
  (state: IState) =>
    ({
      userInfo: state.userInfo
    } as IStateProps),
  dispatch =>
    bindActionCreators(
      {
        userEntersEmail
      },
      dispatch
    ) as IActionProps
)(Email);



// WEBPACK FOOTER //
// ./src/input-components/Email.tsx